import React, { Component } from "react";
import "./service.css";

import RightPane from "./right";
class ServiceSection extends Component {
  render() {
    return (
      <div id="main-service">
        <RightPane />
      </div>
    );
  }
}

export default ServiceSection;
